<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="600">
      <c-card class="white" title="근무 일정 이동">
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12" class="pb-0">
            <div class="font-weight-bold text--black subtitle-2"> 기사 : {{ originDriverName }} </div>
          </v-col>
          <v-col cols="12">
            <div class="font-weight-bold text--black subtitle-2"> 차량: {{ originVehiclePlateNo }} </div>
          </v-col>
        </v-row>
        <v-divider class="pr-3 pb-3"></v-divider>
        1.  동일한 차량의 휴무 기사에게 이동이 가능합니다. (근무 일정이 없는 경우 포함)<br>
        2. 기사에게 배정된 예약 내역이 함께 이동합니다.
        <v-row align="center">
          <v-col cols="4"> <v-icon>keyboard_arrow_right</v-icon></v-col>
          <v-col cols="8">
            <v-select v-if="itemFlag" dense solo v-model="targetDriver" menu-props="{offsetY: true}" hide-details
                      placeholder="기사를 선택해주세요" color="navy"
                      :items="drivers" item-text="name" return-object></v-select>
            <span v-else>
              <span>이동가능한 기사가 존재하지 않습니다.</span>
            </span>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-5">
          <c-btn class="mr-1 mt-2" color="blue" outlined @click="replaceDriverSchedule" :disabled="!itemFlag">이동</c-btn>
          <c-btn class="mt-2" color="grey" outlined @click="openFlag = false">취소</c-btn>
        </v-row>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    props : {
      open: {
        type: Boolean,
        default : false
      },
      selectedRow: {
        type : Object,
        default : undefined
      },
      selectedDate: {
        type: String,
      }
    },
    data() {
      return {
        openFlag: false,
        drivers: [],
        driver: {},
        originDriverName:'',
        originVehiclePlateNo:'',
        originDriverId:'',
        originVehicleId:'',
        targetDriver:{},
        itemFlag :true,
      }
    },
    watch: {
      open(newVal) {
        if(this.selectedRow) {
          this.originDriverId = this.selectedRow.items[0].item.driverId;
          this.originVehicleId=this.selectedRow.items[0].item.vehicleId;
          this.originVehiclePlateNo = this.selectedRow.title;
          this.getInfo();
          this.reqVehicleDrivers() // 일정 이동 가능한 기사 LIST
        }
        this.openFlag = newVal;
      },
      openFlag(newVal) {
        this.$emit('update:open', newVal);
      },
    },
    methods: {
      async getInfo() {
        const res = await  this.$api.getDriver(this.originDriverId);
        console.log('getInfo - response', res.data);
        this.originDriverName = res.data.driver.name;

      },
      async reqVehicleDrivers() {
        try {
          const res = await this.$api.getVehicleDrivers(this.selectedDate, this.selectedRow.items[0].item.vehicleId, this.selectedRow.items[0].item.driverId);
           this.drivers = res.data;
          if(res.data.length < 1) {
            this.itemFlag = false;
          } else {
            this.itemFlag = true;
          }
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqVehicleDrivers'})
        }
      },
      async replaceDriverSchedule() {
        let param = {};
        param = {
          'date' : this.selectedDate,
          'targetDriverId' : this.targetDriver.id,
          'driverId' : this.originDriverId,
          'vehicleId' : this.originVehicleId
        };
        this.openFlag = false;
        this.$emit('replaceSchedule', param);
      }
    }
  }
</script>

<style scoped>

</style>
